export enum SpinnerWidth {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  CUSTOM = 'custom',
}
export enum SpinnerRadius {
  SMALL = 16,
  MEDIUM = 32,
  LARGE = 64,
}

export const INDETERMINATE_VALUE = 80;
